const pym = require("./lib/pym");

const MapboxGL = require("mapbox-gl");
const {Map, NavigationControl, Popup} = MapboxGL;
const topojson = require("topojson-client");

const districtData = require("../../data/city-council-elections.json");
const districts = topojson.feature(districtData, districtData.objects.districts);
const points = topojson.feature(districtData, districtData.objects.points);

const results = require("../../data/results.json");

const container = document.querySelector(".map-container .map");

// [-74.255591,40.496115,-73.700009,40.915533]
const map = new Map({
  container: container,
  style: "https://basemaps.cartocdn.com/gl/positron-gl-style/style.json",
  fadeDuration: 0,
  maxBounds: [-74.355772, 40.448137, -73.653333, 40.980042],
  scrollZoom: false,
  dragRotate: false,
  maxZoom: 16,
  maxPitch: 0,
});


map.once("load", async () => {
  map.addControl(new NavigationControl({
    showCompass: false
  }), "top-right");
  map.touchZoomRotate.disableRotation();

  // Sources

  map.addSource("districts", {
    "type": "geojson",
    "data": districts
  });

  map.addSource("points", {
    "type": "geojson",
    "data": points
  });

  // Layers

  map.addLayer({
    "id": "borders",
    "type": "line",
    "source": "districts",
    "paint": {
      "line-width": 1,
      "line-color": "#999"
    }
  }, "watername_ocean");

  map.addLayer({
    "id": "outlines",
    "type": "line",
    "source": "districts",
    "visibility": "none",
    "filter": ["boolean", false],
    "paint": {
      "line-width": 2.5,
      "line-color": "#333"
    }
  }, "watername_ocean");

  map.addLayer({
    "id": "centroids",
    "type": "circle",
    "source": "points",
    "paint": {
      "circle-radius": 14,
      "circle-color": [
        "case", 
        ["==", ["get", "date"], "22-Jun"], "#0C71FA",
        ["==", ["get", "date"], "23-Mar"], "#A9328A",
        "#ccc"
      ]
    }
  }, "watername_ocean");


  map.addLayer({
    "id": "centroid-text",
    "type": "symbol",
    "source": "points",
    "layout": {
      "text-field": ["get", "id"],
      "text-size": 14,
      "text-allow-overlap": true
    },
    "paint": {
      "text-color": "#fff"
    }
  }, "watername_ocean");

  addPopup(map);
});

function addPopup(map) {
  const popup = new Popup({closeButton: true, closeOnClick: true});
  const layer = "centroids";

  const onClick = (coordinates, props) => {
    const parties = {
      "D": "democratic",
      "R": "republican",
      "C": "conservative"
    };

    const district = results[props.id];
    const democrats = district && district["D"] && results[props.id]["D"] || [];
    const republicans = district && district["R"] && results[props.id]["R"] || [];
    const conservatives = district && district["C"] && results[props.id]["C"] || [];

    function table (results) {
      const inactive = results.filter(d => d.candidate === "Inactive ballots")[0];
      results.sort((a, b) => b.votes - a.votes);

      return `<table class="results">
        <thead>
          <tr>
            <th>Candidate</th>
            <th>Votes</th>
            <th>Pct.</th>
          </tr>
        </thead>
        <tbody>
          ${results.filter(d => d.candidate !== "Inactive ballots").map(row => rowTemplate(row)).join("")}
          ${inactive ? rowTemplate(inactive) : ""}
        </tbody>
      </table>
      <p>See <a href="https://projects.thecity.nyc/nyc-2021-primary-election-results/${parties[results[0].party]}.html#city-council-member-${props.id}" target="_top">full ranked choice results</a></p>`;
    }

    function rowTemplate (row) {
      return `<tr>
        <td>${row.website ? `<a href="${row.website}" target="_top">${row.candidate}</a>` : row.candidate}</td>
        <td>${formatNumber(row.votes)}</td>
        <td>${row.candidate !== "Inactive ballots" ? `${row.pct}%` : ""}</td>
      </tr>`;
    }

    const description = `<div class="popup-content">
      <div class="report">
        <h3>District ${props.id}</h3>
        <p>Incumbent: ${props.incumbent}</p>
        ${Array.isArray(democrats) && democrats.length > 0
          ? `<h4>Democratic Primary</h4>`
          + `<p>${props.id === 9 ? "July 13 unofficial results" : "July 20 certified results"}, final ranked choice voting round.<p>`
          + table(democrats)
          : ""
        }
        ${Array.isArray(republicans) && republicans.length > 0
          ? `<h4>Republican Primary</h4>`
          + `<p>${props.id === 50 ? "July 13 unofficial results" : "July 20 certified results"}, final ranked choice voting round.<p>`
          + table(republicans)
          : ""
        }
        ${Array.isArray(conservatives) && conservatives.length > 0
          ? `<h4>Conservative Primary</h4>`
          + `<p>July 20 certified results, final ranked choice voting round.<p>`
          + table(conservatives)
          : ""
        }
      </div>
    </div>`;
    map.setFilter("outlines", ["==", ["get", "id"], props.id]);
    popup.setLngLat(coordinates).setHTML(description).addTo(map);
  };

  map.on("click", layer, e => {
    const coordinates = e.features[0].geometry.coordinates.slice();
    const props = e.features[0].properties;

    onClick(coordinates, props);
  });

  map.on("mouseenter", layer, () => {
    map.getCanvas().style.cursor = "pointer";
  });

  map.on("mouseleave", layer, () => {
    map.getCanvas().style.cursor = "";
  });
}

function formatNumber (s) {
  s = s + "";
  var start = s.indexOf(".");
  if (start == -1) start = s.length;
  for (var i = start - 3; i > 0; i -= 3) {
    s = s.slice(0, i) + "," + s.slice(i);
  }
  return s;
};